/**
 * POST autenticación de usuario contra la API.
 */
import axiosController from "helpers/axiosController";

const POSTLogin = async (usuarioPayload) => {
  try {
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/usuario/login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: usuarioPayload,
    };

    const response = await axiosController.request(config);

    if (response.status === 200) {
      return response; // Retornamos solo los datos relevantes
    }
  } catch (error) {
    if (error.response) {
      // Error de respuesta del servidor
      return { status: error.response.status, data: error.response.data };
    } else if (error.request) {
      // No se recibió respuesta del servidor
      return { status: 500, message: "No se recibió respuesta del servidor" };
    } else {
      // Otro tipo de error
      return { status: 400, message: "Error al realizar la solicitud" };
    }
  }
};

export default POSTLogin;
